import './assets/main.css'
import 'virtual:uno.css'
import 'element-plus/dist/index.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import print from 'vue3-print-nb';
/**
 * 权限控制，如果暂时不检查权限，可以删除下面代码
 */
//import  './utils/permission'

const app = createApp(App)

app.use(createPinia().use(piniaPluginPersistedstate))

app.use(print); // 全局注册打印组件

setupElementPlus(app)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

app.use(router)

app.mount('#app')

